import React from 'react';
import PropTypes from 'prop-types';

/**
 * Renders an empty placeholder cell.
 *
 * @param {object} props - Component props.
 * @param {object} props.cellProps - Render props for the td element.
 * @returns {React.JSX.Element} The rendered empty table cell.
 */
export const EmptyCell = ({ cellProps }) => (
    <td
        {...cellProps}
        className="stats-table__cell stats-table__cell--empty js-player-stats-empty-cell"
    />
);

EmptyCell.propTypes = {
    cellProps: PropTypes.object.isRequired
};
